import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import EntitiesTableFilters from 'components/organisms/TableFilters/EntitiesTableFilters/EntitiesTableFilters';

const StyledCollectionEntitiesTableFilters = styled(EntitiesTableFilters)`
  ${ComponentStyles}
`;

StyledCollectionEntitiesTableFilters.propTypes = {
  theme: PropTypes.object
};

export default StyledCollectionEntitiesTableFilters;
